import React from "react";
import axios from "axios";
import validator from 'validator';
import { v4 as uuidv4 } from 'uuid';
import { notifications } from '@mantine/notifications';
import { Drawer, Button, Text, ActionIcon, Group } from '@mantine/core';
import { IconRefresh, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContextSU } from "../../context/loginContextSU";
import { BE_API_SU_ONE, utils } from "../../utils/globalVariables";
import { regexLimitChar, regexNoSpace } from "../../utils/globalFunctions";

import InputComponent from "../../components/general/InputComponent";
import ModalResponse from "../../components/general/ModalResponse";

const SUDataUserReset = ({
    stateShow,
    fnShow,
    stateData,
    fnSuccessEdit
}) => {

    const mountedRef = React.useRef(true);
    const { loginContextSU, handleSetLoginContextSU } = useLoginContextSU();

    const notificationId = React.useRef({
        errorSubmitData: 'SUDataUserReset-1',
        successSubmitData: 'SUDataUserReset-2',
    })

    const constDefaultUserName = {
        id: 'edit--defaultUserName',
        label: `Username (${utils.minCharUsername}-${utils.maxCharUsername} digit)`,
        withAsterisk: true,
        placeholder: 'Username',
        value: '',
        description: 'Username dapat diubah kemudian oleh user yang bersangkutan.',
        error: '',
    }

    const constDefaultUserPassword = {
        id: 'edit--defaultUserPassword',
        label: `Password (${utils.minCharPassword}-${utils.maxCharPassword} digit)`,
        withAsterisk: true,
        placeholder: 'Password',
        value: '',
        description: 'Password dapat diubah kemudian oleh user yang bersangkutan.',
        error: '',
    }

    const [data, setData] = React.useState({
        userDefaultUsername: constDefaultUserName,
        userDefaultPassword: constDefaultUserPassword,

        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const handleSubmit = () => {
        setData(d => ({
            ...d,
            userDefaultUsername: { ...d.userDefaultUsername, error: '' },
            userDefaultPassword: { ...d.userDefaultPassword, error: '' },
        }));

        if (validator.isEmpty(data.userDefaultUsername.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, userDefaultUsername: { ...d.userDefaultUsername, error: 'Default Username Harus Diisi !' } }));
        } else if (!validator.isLength(data.userDefaultUsername.value, { min: utils.minCharUsername, max: utils.maxCharUsername })) {
            setData(d => ({ ...d, userDefaultUsername: { ...d.userDefaultUsername, error: `Default Username Diisi ${utils.minCharUsername + '-' + utils.maxCharUsername} Digit` } }));
        } else if (validator.isEmpty(data.userDefaultPassword.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, userDefaultPassword: { ...d.userDefaultPassword, error: 'Default Password Harus Diisi !' } }));
        } else if (!validator.isLength(data.userDefaultPassword.value, { min: utils.minCharPassword, max: utils.maxCharPassword })) {
            setData(d => ({ ...d, userDefaultPassword: { ...d.userDefaultPassword, error: `Default Password Diisi ${utils.minCharPassword + '-' + utils.maxCharPassword} Digit` } }));
        } else {
            setData(d => ({ ...d, submitLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContextSU.syswebapp);
            formDT.append('id', stateData.user_id);
            formDT.append('username', data.userDefaultUsername.value);
            formDT.append('password', data.userDefaultPassword.value);

            axios({
                method: 'post',
                url: BE_API_SU_ONE + '/reset_username_password',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                if (response.data.flag_status === 'isset') {

                    setData(d => ({
                        ...d,
                        userDefaultUsername: { ...d.userDefaultUsername, value: '' },
                        userDefaultPassword: { ...d.userDefaultPassword, value: '' }
                    }))

                    notifications.show({
                        id: notificationId.current.successSubmitData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Submit Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    });

                    fnSuccessEdit();
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'duplicate-username') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: `Username ${response.data.suspect} sudah pernah didaftarkan. Coba pilihan lain.`,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContextSU(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContextSU(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Reset Username dan Password User</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <InputComponent
                    stateId={data.userDefaultUsername.id}
                    stateWithAsterisk={data.userDefaultUsername.withAsterisk}
                    stateLabel={data.userDefaultUsername.label}
                    stateDescription={data.userDefaultUsername.description}
                    statePlaceHolder={data.userDefaultUsername.placeholder}
                    stateValue={data.userDefaultUsername.value}
                    stateError={data.userDefaultUsername.error}
                    stateRightSection={
                        <IconRefresh
                            size='1rem'
                            style={{ cursor: 'pointer' }}
                            color="#1864AB"

                            onClick={() => {
                                setData(d => ({
                                    ...d,
                                    userDefaultUsername: {
                                        ...d.userDefaultUsername,
                                        value: regexLimitChar(regexNoSpace(uuidv4()), utils.generateUsernameLength)
                                    }
                                }))
                            }}
                        />
                    }

                    stateMT="1.5rem"

                    fnOnChange={(e) => setData(d => ({
                        ...d,
                        userDefaultUsername: {
                            ...d.userDefaultUsername,
                            value: regexNoSpace(e.target.value)
                        }
                    }))}
                />

                <InputComponent
                    stateId={data.userDefaultPassword.id}
                    stateWithAsterisk={data.userDefaultPassword.withAsterisk}
                    stateLabel={data.userDefaultPassword.label}
                    stateDescription={data.userDefaultPassword.description}
                    statePlaceHolder={data.userDefaultPassword.placeholder}
                    stateValue={data.userDefaultPassword.value}
                    stateError={data.userDefaultPassword.error}
                    stateRightSection={
                        <IconRefresh
                            size='1rem'
                            style={{ cursor: 'pointer' }}
                            color="#1864AB"

                            onClick={() => {
                                setData(d => ({
                                    ...d,
                                    userDefaultPassword: {
                                        ...d.userDefaultPassword,
                                        value: regexLimitChar(regexNoSpace(uuidv4()), utils.generatePasswordLength)
                                    }
                                }))
                            }}
                        />
                    }

                    stateMT="1.5rem"

                    fnOnChange={(e) => setData(d => ({
                        ...d,
                        userDefaultPassword: {
                            ...d.userDefaultPassword,
                            value: regexNoSpace(e.target.value)
                        }
                    }))}
                />

                <Button
                    fullWidth
                    mt='1.5rem'
                    loading={data.submitLoading}
                    onClick={handleSubmit}
                >
                    Submit Data
                </Button>
            </Drawer>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default SUDataUserReset;